module.exports = __webpack_public_path__ + "fonts/PFBeauSansPro-Bold.99b531eb.eot";